import * as React from 'react';

interface InputErrorMessageProps {
  showError: boolean;
  message: string;
}

export default class InputErrorMessage extends React.PureComponent<InputErrorMessageProps, {}> {
  render(): JSX.Element | null {
    if (!this.props.showError) {
      return null;
    }
    return <p className="help is-danger">{this.props.message}</p>;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/inputErrorMessage.tsx